export default "__VITE_ASSET__D0$J6mNw__"